import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import { getApiBaseUrl, GET_ACTIVITIES } from "../Config/Config";
import { Spin, Tooltip } from "antd";

const AssetActivityLog = () => {
  const [auditLogData, setAuditLogData] = useState([]);
  const [loadingAuditLog, setLoadingAuditLog] = useState(true);
  const [errorAuditLog, setErrorUsers] = useState(null);
  // const [userData, setUserData] = useState();
  // useEffect(() => {
  //   const user = JSON.parse(sessionStorage.getItem("user"));
  //   setUserData(user);
  // }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(`${getApiBaseUrl()}${GET_ACTIVITIES}`);
        const logData = await response.json();
        setAuditLogData(logData?.ResultData);
      } catch (err) {
        setErrorUsers(err.message);
      } finally {
        setLoadingAuditLog(false);
      }
    };

    fetchUsers();
  }, []);
  console.log(auditLogData, loadingAuditLog, errorAuditLog);

  const columns = [
    {
      title: "Date",
      dataIndex: "PerformedOn",
      key: "Date",
      render: (date) => {
        if (!date) return "";
        const d = new Date(date);
        const day = String(d.getUTCDate()).padStart(2, "0");
        const month = String(d.getUTCMonth() + 1).padStart(2, "0");
        const year = d.getUTCFullYear();
        return `${day}/${month}/${year}`;
      },
      sorter: (a, b) => new Date(a.PerformedOn) - new Date(b.PerformedOn),
    },
    {
      title: "Time",
      dataIndex: "PerformedOn",
      key: "Time",
      render: (dateString) => {
        if (!dateString) return "";
        const d = new Date(dateString);
        const hours = String(d.getUTCHours()).padStart(2, "0");
        const minutes = String(d.getUTCMinutes()).padStart(2, "0");
        // const seconds = String(d.getUTCSeconds()).padStart(2, "0");
        return `${hours}:${minutes}`;
      },
      sorter: (a, b) =>
        new Date(a.PerformedOn).getTime() - new Date(b.PerformedOn).getTime(),
    },

    {
      title: "User ID",
      dataIndex: "username",
      key: "username",
      sorter: (a, b) => a.username - b.username,
    },
    // {
    //   title: "Description",
    //   dataIndex: "Notes",
    //   key: "Description",
    //   sorter: (a, b) => a.Notes.localeCompare(b.Notes),
    // },
    {
      title: "Description",
      dataIndex: "Notes",
      key: "Description",
      sorter: (a, b) => a.Notes?.localeCompare(b.Notes),
      render: (text) => (
        <Tooltip title={text}>
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "35vw",
            }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Status",
      dataIndex: "IsSucces",
      key: "Status",
      render: (status) => (
        <span style={{ color: status ? "green" : "red" }}>
          {status ? "Success" : "Fail"}
        </span>
      ),
      sorter: (a, b) => a.IsSucces - b.IsSucces,
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Audit Trail
                  </h4>
                </ol>
              </nav>
              <h6>Track your Logs</h6>
            </div>
          </div>
        </div>
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
            <div className="search-set mt-5"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              {/* <div className="dropdown me-2">
                <Link
                  to="#"
                  className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Category
                </Link>
                <ul className="dropdown-menu  dropdown-menu-end p-3">
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      HEPA
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Pre-Filter
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Bag Filter
                    </Link>
                  </li>
                  {/* <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Diagnostics
                    </Link>
                  </li> */}
              {/* </ul>
              </div> */}
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {loadingAuditLog ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : auditLogData.length > 0 ? (
                <Table columns={columns} dataSource={auditLogData} />
              ) : (
                <p className="text-center my-4">No data available</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <></>
    </div>
  );
};

export default AssetActivityLog;
